/*globals $ */



import Scene from './Scene';


class SceneManager {
  shuffleArray(array) {
    for(let i = array.length - 1; i > 0; i--){
      let r = Math.floor(Math.random() * (i + 1));
      let tmp = array[i];
      array[i] = array[r];
      array[r] = tmp;
    }
  }
  constructor(mainApp, initPage = 'intro') {
    this.mainApp = mainApp;
    this.$container = $('.SceneManager');
    this.quizAnswerCount = 0;
    // console.log('SceneManager');
    this.correctCount = 0;


    this.quizOriginalSetting = [
      [
        'L-a1','L-a2','L-b1','L-b2'
      ],
      [
        'M-a1','M-a2','M-b1','M-b2'
      ],
      [
        'H-1','H-2','H-4','H-5'
      ]
    ];
    // console.log('初期設定', this.quizOriginalSetting);

    this.currentQuizRoute = [];
    this.currentQuizRoute.push(this.quizOriginalSetting[0][0]);
    this.currentQuizRoute.push(this.quizOriginalSetting[0][1]);
    this.currentQuizRoute.push(this.quizOriginalSetting[1][0]);
    this.currentQuizRoute.push(this.quizOriginalSetting[2][0]);
    this.currentQuizRoute.push(this.quizOriginalSetting[2][1]);




    this.scenes = [];

    $('.Scene').each((i, e) => {
      this.scenes.push(new Scene(this, $(e)));
    });

    $(document).on('click', '.js-change-scene', (e) => {
      this.goto($(e.currentTarget).attr('data-scene-goto'));
      return false;
    });


    $('.js-start-quiz').on('click', () => {
      $('.Indicator').attr('data-count', '1');
      this.resetQuizSetting();
      this.goto(this.currentQuizRoute[this.quizAnswerCount]);
    });

    $('.js-restart').on('click', () => {
      for(let i = 0; i < this.scenes.length; i++) {
        this.scenes[i].reset();
      }
      this.resetQuizSetting();
      this.goto('intro');
    });

    /*
    $('.js-next-quiz').on('click', () => {
      this.goto('quiz-02');
    });
    */

    this.goto(initPage);
  }
  resetQuizSetting() {
    this.quizAnswerCount = 0;
    this.correctCount = 0;
    this.shuffleArray(this.quizOriginalSetting[0]);
    this.shuffleArray(this.quizOriginalSetting[1]);
    this.shuffleArray(this.quizOriginalSetting[2]);
    // console.log('シャッフル後', this.quizOriginalSetting);

    this.currentQuizRoute = [];
    this.currentQuizRoute.push(this.quizOriginalSetting[0][0]);
    this.currentQuizRoute.push(this.quizOriginalSetting[0][1]);
    this.currentQuizRoute.push(this.quizOriginalSetting[1][0]);
    this.currentQuizRoute.push(this.quizOriginalSetting[2][0]);
    this.currentQuizRoute.push(this.quizOriginalSetting[2][1]);
    // console.log('quizRoute', this.currentQuizRoute);
  }

  nextStep() {
    this.quizAnswerCount++;
    // console.log('this.quizAnswerCount', this.quizAnswerCount);
    $('.Indicator').attr('data-count', this.quizAnswerCount + 1);

    if(this.quizAnswerCount == 5) {
      // console.log('リザルト画面');
      this.goto('result');
    } else {
      this.goto(this.currentQuizRoute[this.quizAnswerCount]);
    }
  }

  goto(target) {
    let isChangeScene = false;
    for(let i = 0; i < this.scenes.length; i++) {
      if(target == this.scenes[i].id) {
        isChangeScene = true;
        if(target != 'result' && target != 'intro') {
          this.scenes[i].fadein(this.quizAnswerCount);
        } else {
          this.scenes[i].fadein();
        }

      } else {
        this.scenes[i].fadeout();
      }
    }

    if(isChangeScene) {
      if(target == 'intro') {
        $('.Header').addClass('Header--hide');
      } else {
        $('.Header').removeClass('Header--hide');
      }
    } else {
      console.log('対象シーンが存在しません');
    }

  }
}

export default SceneManager;
